import type { AxiosInstance } from "axios";

export type UpdateUserRoleResult = {
  role_id: number;
};

export async function updateUserRole(
  client: AxiosInstance,
  userId: number,
  roleId: number
): Promise<UpdateUserRoleResult> {
  const response = await client.put(`/api/adm/users/${userId}/role`, {
    role_id: roleId,
  });

  const payload = response.data?.data ?? {};
  return {
    role_id: Number(payload.role_id ?? roleId),
  };
}
